// The journal keeps each batch until records AND the inventoryUpdate publication
// are acknowledged by the server. It covers this device, not backend processing.
export function summarizeQueue(batches) {
  return { pendingRecords: batches.reduce((sum, batch) => sum + batch.records.length, 0) };
}

export function syncState({ pendingRecords, errorsCount, current }) {
  if (errorsCount) return 'error';
  if (pendingRecords) return 'sending';
  return current ? 'synced' : 'unconfirmed';
}
